import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { SupportButton } from '../../containers/Dashboard/components/AppBar/styles';
import Button, { buttonColors, buttonSizes } from '../Button';
import { REACT_APP_TAWK_TO_PROPERTY_ID, REACT_APP_TAWK_TO_WIDGET_ID } from '../../app/config';

export const TawkMessengerContext = createContext(null);

const TawkMessengerProviderComponent = ({ children }) => {
  const tawkMessengerRef = useRef();
  const [isTawkLoaded, setIsTawkLoaded] = useState(false);
  const [unreadCount, setUnreadCount] = useState(() => {
    const savedCount = localStorage.getItem('twk_unread_count');
    return savedCount ? parseInt(savedCount, 10) : 0;
  });
  const updateUnreadCount = count => {
    setUnreadCount(typeof count === 'number' && count >= 0 ? count : 0);
  };
  const sessionAuthorized = useSelector(state => state.session?.authorized);

  useEffect(() => {
    localStorage.setItem('twk_unread_count', unreadCount.toString());
  }, [unreadCount]);

  useEffect(() => {
    if (!isTawkLoaded || !tawkMessengerRef.current) return;

    if (sessionAuthorized) {
      tawkMessengerRef.current.hideWidget();
    } else {
      tawkMessengerRef.current.showWidget();
    }
  }, [sessionAuthorized, isTawkLoaded]);

  return (
    <TawkMessengerContext.Provider value={{ tawkMessengerRef, unreadCount }}>
      {children}
      <TawkMessengerReact
        propertyId={REACT_APP_TAWK_TO_PROPERTY_ID}
        widgetId={REACT_APP_TAWK_TO_WIDGET_ID}
        ref={tawkMessengerRef}
        onUnreadCountChanged={updateUnreadCount}
        customStyle={{ zIndex: 1000 }}
        onLoad={() => {
          setIsTawkLoaded(true);
        }}
      />
    </TawkMessengerContext.Provider>
  );
};

TawkMessengerProviderComponent.propTypes = {
  children: PropTypes.node.isRequired,
};

TawkMessengerProviderComponent.defaultProps = {};

const mapStateToProps = state => ({});

export const TawkMessengerProvider = connect(mapStateToProps)(TawkMessengerProviderComponent);

export const TawkToSupportButton = () => {
  const { tawkMessengerRef, unreadCount } = useContext(TawkMessengerContext);

  const toggleChat = () => {
    tawkMessengerRef.current.toggle();
  };

  return (
    <SupportButton>
      <Button
        color={buttonColors.secondary}
        onClick={toggleChat}
        title="Chat with us!"
        size={buttonSizes.small}
      >
        Support
      </Button>
      {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
    </SupportButton>
  );
};
